var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<button type=\"button\" class=\"btn btn-light dropdown-toggle\" ng-disabled=\"$ctrl.componentDisabled\">\n{{ 'StorageCurrency.' + $ctrl.unit.storageCurrency | translate }}/{{ 'StorageQuantityUnit.' + $ctrl.unit.storageQuantityUnit | pkpStorageQuantityTranslate }}/{{ 'StoragePriceRuntime.' + $ctrl.unit.storagePriceRuntime | translate }}\n</button>\n";
var id1="app/storage-offer/storage-price-unit.component.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;